import type { Robot } from '$lib/patterns/strategy/examples/types';
type Message = Robot.Message;
import Dad_Joke_Bot_Maker from './shared/inheritance/Dad_Joke_Bot';
import Stoicism_Bot_Maker from './shared/inheritance/Stoicism_Bot';











abstract class Chatbot {
	abstract readonly name: string;
	abstract readonly avatar: string;

	abstract getContent(): Promise<string>;
	async getMessage(): Promise<Message> {
		return {
			author: this.name,
			avatar: this.avatar,
			// #N: This should already be a signal that we're heading in the wrong direction.
			// #N: The same class is using a generic and a specific method at the same time.
			content: await this.getContent(),
			time: new Date().toLocaleTimeString(),
		}
	}
}







const Dad_Joke_Bot = Dad_Joke_Bot_Maker(Chatbot);
const Stoicism_Bot = Stoicism_Bot_Maker(Chatbot);

export default {
	Bot: {
		class: Chatbot,
	},
	Dad_Joke_Bot: {
		class: Dad_Joke_Bot,
		init: () => new Dad_Joke_Bot(),
	},
	Stoicism_Bot: {
		class: Stoicism_Bot,
		init: () => new Stoicism_Bot(),
	},
}
